import {
  SidePanel,
  ButtonPrimary,
  ButtonSecondary,
  IconLoader,
  PermissionEnum,
} from '@ui/src';
import CategoryForm from '../../../components/charts/charts-panel/charts-panel-category';
import useCategoryEdit from './hooks/use-edit';

import cn from '../styles.module.css';

const CategoryEdit = (): React.JSX.Element => {
  const {
    typeOptions,
    requestInProgress,
    selectedCategoryIsLoading,
    activePermissions,
    name,
    group,
    control,
    errors,
    onSubmit,
    categoryId,
    panelIsOpen,
    handleClose,
  } = useCategoryEdit();

  let content;

  if (selectedCategoryIsLoading) {
    content = (
      <div className={cn.selectedCategoryLoading}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <CategoryForm
        name={name}
        control={control}
        group={group}
        typeOptions={typeOptions}
        errors={errors}
        categoryId={categoryId}
      />
    );
  }

  return (
    <SidePanel
      closeOnClickOutside={false}
      isOpen={panelIsOpen}
      onClose={handleClose}
      title={`Category ${
        activePermissions?.includes(
          PermissionEnum.ACCOUNTS_CHART_EDIT_CATEGORY_ACTION,
        )
          ? 'Edit'
          : 'Info'
      }`}
      sidepanelExpandedKey="charts-category-edit"
      className={cn.chartSidePanel}
      parent={document.getElementById('chart-modal') as HTMLElement}
      footer={
        <>
          {activePermissions?.includes(
            PermissionEnum.ACCOUNTS_CHART_EDIT_CATEGORY_ACTION,
          ) && (
            <ButtonPrimary
              text={requestInProgress ? 'Loading...' : 'Save'}
              disabled={requestInProgress}
              onClick={onSubmit}
            />
          )}
          <ButtonSecondary text="Close" onClick={handleClose} />
        </>
      }
    >
      {content}
    </SidePanel>
  );
};

export default CategoryEdit;
